module.exports = __webpack_public_path__ + "img/sheriff_footer-logo.6c25f053.svg";